module.exports = __webpack_public_path__ + "images/assets/46e123d80df39d3f96ad2ba39ea43ea5.svg";